import { useTranslation } from 'react-i18next'
import type { DownloadProfile, MediaRoot } from '../lib/api'

export function DownloadProfileSummary({ profile, roots }: { profile?: DownloadProfile; roots: MediaRoot[] }) {
  const { t } = useTranslation()
  if (!profile) return null
  const root = roots.find((item) => item.id === profile.mediaRootId)
  const target = `${root?.label ?? profile.mediaRootId}${profile.baseSubpath ? ` / ${profile.baseSubpath}` : ''}`
  const options = [
    t(`downloadDialog.${profile.quality.toLowerCase()}`),
    profile.createTopicFolder ? t('profiles.topicFolderShort') : null,
    profile.subtitlesEnabled ? t('downloadDialog.subtitles') : t('profiles.noSubtitles'),
    profile.infoFileEnabled ? t('downloadDialog.info') : t('profiles.noInfoFile'),
  ].filter(Boolean).join(' · ')

  return <div className="download-profile-summary">
    <span><strong>{t('profiles.target')}:</strong> {target}</span>
    <span><strong>{t('profiles.filename')}:</strong> {profile.filenameTemplate}</span>
    <small>{options}</small>
  </div>
}
